module.exports = __webpack_public_path__ + "img/3.894ca930.jpg";